/* eslint-disable */
import environments, { Environment } from '@/support/Environments';
import Session from '@/support/Session';
import Storage from '@/support/Storage';
import { findIndex } from 'lodash';

export class Config {
  public static environment: Environment;

  public static environments: Environment[] = environments;

  public static setEnvironment(environment?: Environment) {
    if (environment) {
      // manually set environment
      Config.environment = environment;
      return;
    }

    // Search via hostname
    const index = findIndex(Config.environments, (environment: Environment) => {
      return environment.hostnames.includes(window.location.hostname);
    });

    if (index !== -1) {
      Config.environment = Config.environments[index];
      return;
    }

    throw new Error('No valid hostname found. Make sure that environments.ts is set properly');
  }

  public static get(key: string): ConfigValue {
    if (Session.has(key)) {
      return Session.get(key) as ConfigValue;
    }

    if (Storage.has(key)) {
      return Storage.get(key) as ConfigValue;
    }

    if (! Config.environment) {
      Config.setEnvironment();
    }
    return Config.environment?.config[key];
  }

  public static set(key: string, value: ConfigValue): ConfigValue {
    if (! Config.environment) {
      Config.setEnvironment();
    }

    if (! Config.environment) {
      return;
    }

    Storage.set(key, `${value}`);

    return Config.environment.config[key] = value;
  }

  public static all(): { [key: string]: ConfigValue } {
    if (! Config.environment) {
      Config.setEnvironment();
    }

    if (! Config.environment) {
      return {};
    }

    return Config.environment.config;
  }
}

export type ConfigValue = boolean | string | number | undefined;
